import { connect } from 'react-redux';
import PanelProperties from '../../components/handoff/PanelProperties';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
import * as css from '../../utils/handoff/css';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        blendMode: css.getBlendMode(element),
        blur: handoff.getElementBlur(element),
        layout: handoff.getElementLayout(element),
        opacity: css.getOpacity(element),
        radius: handoff.getElementRadius(element),
    };
}
export default connect(mapStateToProps)(PanelProperties);
